import { useEffect, useState } from 'react';

/**
 * Returns the seconds remaining until `deadline` (epoch ms).
 * Re-renders ~10x/sec for smooth countdown; stops at 0.
 * Pass `null`/`undefined` to disable.
 */
export function useVoteTimer(deadline: number | null | undefined): number {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        if (!deadline) return undefined;
        if (Date.now() >= deadline) {
            setNow(Date.now());
            return undefined;
        }
        const id = window.setInterval(() => {
            const t = Date.now();
            setNow(t);
            if (t >= deadline) window.clearInterval(id);
        }, 100);
        return () => window.clearInterval(id);
    }, [deadline]);

    if (!deadline) return 0;
    return Math.max(0, Math.ceil((deadline - now) / 1000));
}
